export var getHostName = function getHostName(host) {
  var QA_ENV = 'qa';
  var UAT_ENV = 'uat';
  var LOCALHOST_ENV = 'localhost';
  if (host) {
    if (host.includes(QA_ENV)) {
      return "".concat(QA_ENV, "_");
    } else if (host.includes(UAT_ENV)) {
      return "".concat(UAT_ENV, "_");
    } else if (host.includes(LOCALHOST_ENV)) {
      return "".concat(QA_ENV, "_");
    } else {
      return '';
    }
  }
  return '';
};